module.exports = __webpack_public_path__ + "static/media/J-W-Anderson-Black-Small-Velvet-Pierce-Shoulder-Bag-Lyst.19750f32.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/bags/J-W-Anderson-Black-Small-Velvet-Pierce-Shoulder-Bag-Lyst.png
// module id = 221
// module chunks = 0